import React, { useState } from "react";
import { Icon } from "@iconify/react";
import { Button } from "@heroui/react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import DefaultImage from "../../../assets/default-product-image.webp";
import { add_product_thunk } from "../../../reducers/slices/basket/thunks/add_product_thunk";
import { setIsAddingToBasket } from "../../../reducers/slices/basket/basket";
import { calculate_basket_thunk } from "../../../reducers/slices/basket/thunks/calculate_basket_thunk";
import { setMainModal } from "../../../reducers/slices/main";
import { getDefaultVariant } from "../../../helpers/getDefaultVariant";
import { getProductImageUrl } from "../../../helpers/getProductImageUrl";
import { IncrementButton } from "../../increment_button";
import { update_quantity } from "../../../api/calls/basket/update_quantity";
import { IN_STOCK, OUT_OF_STOCK } from "../../../screens/pages/shop/constants";
import { formatPrice } from "../../../helpers/formatPrice";
export const ProductBanner = ({ product }) => {
    const { status, on_promotion } = product;
    const isOutOfStock = status === OUT_OF_STOCK;
    if (isOutOfStock) {
        return (React.createElement("div", { className: "bg-gray-500 text-white text-center text-xs py-1 px-2 absolute top-3 left-3 rounded-md" },
            React.createElement("span", { className: "font-semibold" }, "Out of Stock")));
    }
    if (on_promotion) {
        return (React.createElement("div", { className: "bg-error text-white text-center text-xs py-1 px-2 absolute top-3 left-3 rounded-md" },
            React.createElement("span", { className: "font-semibold" }, "On Promotion")));
    }
    return null;
};
export function ProductGridViewItem(props) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { product } = props;
    const [quantity, setQuantity] = useState(1);
    const { user } = useSelector((state) => state.userState);
    const { sell_out_of_stock } = user;
    const { addingToBasket, basket } = useSelector((state) => state.basketState);
    const { id, isAddingToBasket } = addingToBasket;
    const { product_list } = basket || {};
    const inStock = product?.status === IN_STOCK;
    const canAddToBasket = sell_out_of_stock === true || inStock;
    const imageUrl = getProductImageUrl(product);
    return (React.createElement("div", { className: "w-full rounded-xl overflow-hidden flex flex-col gap-1 pb-1 cursor-pointer hover:opacity-80 ease-in-out duration-150" },
        React.createElement("div", { className: "relative", onClick: () => navigate(`/product/${product._id}`) },
            React.createElement("div", { className: "flex min-h-[323px]" },
                React.createElement("img", { className: `${imageUrl ? "object-cover opacity-100" : "object-contain opacity-20"}`, alt: product?.title, src: imageUrl ?? DefaultImage, onError: (event) => {
                        event.target.src = DefaultImage;
                        event.target.className = "object-contain opacity-20";
                    } })),
            React.createElement("div", { className: "flex flex-col w-full text-md p-1 h-[120px]" },
                React.createElement("div", { className: "text-xs font-normal" }, product?.sku),
                React.createElement("div", { className: "flex flex-1" },
                    React.createElement("div", { className: "text-sm font-semibold line-clamp-3" }, product?.title)),
                React.createElement("div", { className: "flex flex-col justify-end flex-nowrap text-nowrap" },
                    React.createElement("div", { className: "text-sm my-auto text-end font-semibold" }, `${formatPrice({
                        value: product?.price,
                        decimalPlaces: 2,
                    })}`))),
            React.createElement(ProductBanner, { product: product })),
        React.createElement("div", { className: "flex justify-between gap-2 px-1" },
            React.createElement(IncrementButton, { onChange: (value) => setQuantity(value) }),
            React.createElement(Button, { color: "primary", size: "sm", fullWidth: true, radius: "sm", isDisabled: !canAddToBasket || (isAddingToBasket && id !== product._id), isLoading: isAddingToBasket && id === product._id, type: "submit", endContent: canAddToBasket && React.createElement(Icon, { icon: "lucide:handbag", width: "15", height: "15" }), onPress: () => {
                    const defaultVariant = getDefaultVariant(product?.variations || []);
                    const existingProduct = product_list?.find((i) => product.sku === i.sku);
                    if (existingProduct) {
                        // If product already in basket, just update the quantity
                        dispatch(setIsAddingToBasket({ id: product._id, isAddingToBasket: true }));
                        update_quantity({
                            _id: basket?._id,
                            product: {
                                _id: existingProduct._id,
                                quantity: quantity.toString(),
                            },
                        }).then((response) => {
                            if (response.success) {
                                dispatch(calculate_basket_thunk(response));
                            }
                            else {
                                dispatch(setIsAddingToBasket({ id: "", isAddingToBasket: false }));
                                dispatch(setMainModal({ title: "Something went wrong!", messages: [response.message] }));
                            }
                        });
                    }
                    else {
                        dispatch(add_product_thunk({
                            product: product,
                            quantity: quantity,
                            selectedVariations: defaultVariant ? [defaultVariant] : null,
                        }));
                    }
                } }, canAddToBasket ? "Add to Cart" : "Out of Stock"))));
}
